import ImageBox from './image-box';

export default ImageBox;



// WEBPACK FOOTER //
// ./src/components/image-box/index.js